// {{WORKTREE_ROOT}}/picosponsorconsole/packages/design/src/strings.ts
// PLAN2 WP09 — K-09: the design package types no copy. Components call t(S.key) through DesignI18nProvider.
export type Msg = readonly [section: string, id: string];

export const S = {
  productName: ["common", "product-name"], // owned by WP08 (RL-03); listed so strings.test.ts proves it exists
  gradeVerified: ["common", "grade-verified"],
  gradeCaptured: ["common", "grade-captured"],
  gradeAttested: ["common", "grade-attested"],
  gradeMissing: ["common", "grade-missing"],
  gradeUnconfirmed: ["common", "grade-unconfirmed"],
  gradePendingNone: ["common", "grade-pending-none"],
  gradePendingAwaiting: ["common", "grade-pending-awaiting"],
  gradePendingScheduled: ["common", "grade-pending-scheduled"],
  legendTitle: ["common", "grade-legend-heading"],
  legendVerified: ["common", "grade-legend-verified"],
  legendCaptured: ["common", "grade-legend-captured"],
  legendAttested: ["common", "grade-legend-attested"],
  legendMissing: ["common", "grade-legend-missing"],
  legendUnconfirmed: ["common", "grade-legend-unconfirmed"],
  dirWeOwe: ["common", "dir-we-owe"],
  dirTheyOwe: ["common", "dir-they-owe"],
  dirYouGet: ["common", "dir-you-get"],
  dirYouOwe: ["common", "dir-you-owe"],
  statKept: ["common", "stat-kept"],
  statDue: ["common", "stat-due"],
  statAtRisk: ["common", "stat-at-risk"],
  statMissed: ["common", "stat-missed"],
  statusOnTrack: ["common", "status-on-track"],
  statusKept: ["common", "status-kept"],
  statusAtRisk: ["common", "status-at-risk"],
  statusMissed: ["common", "status-missed"],
  statusWaived: ["common", "status-waived"],
  statusDelivered: ["common", "status-delivered"],
  evidenceCoverage: ["common", "evidence-coverage"],
  dealNext: ["common", "deal-next"],
  dealRenews: ["common", "deal-renews"],
  dealRoomVisit: ["common", "deal-room-visit"],
  actionAccept: ["common", "action-accept"],
  actionDismiss: ["common", "action-dismiss"],
  actionConfirm: ["common", "action-confirm"],
  actionConfirmPromise: ["common", "action-confirm-promise"],
  actionSnooze: ["common", "action-snooze"],
  actionFix: ["common", "action-fix"],
  actionSkip: ["common", "action-skip"],
  actionPark: ["common", "action-park"],
  actionReject: ["common", "action-reject"],
  actionApprove: ["common", "action-approve"],
  actionAskAgain: ["common", "action-ask-again"],
  actionRetry: ["common", "action-retry"],
  actionBackHome: ["common", "action-back-home"],
  actionSeePlans: ["common", "action-see-plans"],
  actionClose: ["common", "action-close"],
  actionRemove: ["common", "action-remove"],
  actionNotThisOne: ["common", "action-not-this-one"],
  why: ["common", "why"],
  whyTitle: ["common", "why-capital"],
  regionUs: ["common", "region-us"],
  regionEu: ["common", "region-eu"],
  costCredits: ["common", "cost-credits"],
  costTime: ["common", "cost-time"],
  costPages: ["common", "cost-pages"],
  costUsed: ["common", "cost-used"],
  termsLabel: ["common", "terms-label"],
  termsPlain: ["common", "terms-plain"],
  meterCredits: ["common", "meter-credits"],
  meterCreditsLeft: ["common", "meter-credits-left"],
  stageRead: ["common", "stage-read"],
  stageConfirm: ["common", "stage-confirm"],
  stageActivate: ["common", "stage-activate"],
  stageDeliver: ["common", "stage-deliver"],
  stageProve: ["common", "stage-prove"],
  stageRecap: ["common", "stage-recap"],
  stageReport: ["common", "stage-report"],
  stageRenew: ["common", "stage-renew"],
  migrationClear: ["common", "migration-clear"],
  migrationAmbiguous: ["common", "migration-ambiguous"],
  migrationSkipped: ["common", "migration-skipped"],
  migrationMerged: ["common", "migration-merged"],
  availAvailable: ["common", "avail-available"],
  availReserved: ["common", "avail-reserved"],
  availHeld: ["common", "avail-held"],
  availSold: ["common", "avail-sold"],
  availCandidate: ["common", "avail-candidate"],
  trayTotal: ["common", "tray-total"],
  roomDelivered: ["common", "room-sum-delivered"],
  roomComing: ["common", "room-sum-coming"],
  roomNeedsApproval: ["common", "room-sum-needs-approval"],
  roomYouOwe: ["common", "room-sum-you-owe"],
  sevCritical: ["common", "severity-critical"],
  sevHigh: ["common", "severity-high"],
  sevMedium: ["common", "severity-medium"],
  sevLow: ["common", "severity-low"],
  sevOutage: ["common", "severity-outage"],
  findingProofFound: ["common", "finding-proof-found"],
  findingProofMissing: ["common", "finding-proof-missing"],
  findingProspect: ["common", "finding-prospect"],
  findingSignal: ["common", "finding-signal"],
  findingBroken: ["common", "finding-broken"],
  findingTheyOwe: ["common", "finding-they-owe"], // ── WP37 ──
  findingFound: ["findings", "variant-found"], // ── WP38 ── the neutral variant's word reuses the findings filter's id (WP38 §20: findings.variant-found, "Found")
  confidenceHigh: ["common", "confidence-high"],
  confidenceMedium: ["common", "confidence-medium"],
  confidenceLow: ["common", "confidence-low"],
  findingConfidence: ["common", "finding-confidence"],
  findingReplay: ["common", "finding-replay"],
  findingSource: ["common", "finding-source"],
  findingFoundOn: ["common", "finding-found-on"],
  codeLegend: ["common", "code-legend"],
  codeSingle: ["common", "code-single"],
  chainWaiting: ["fulfil", "chain-waiting"],
  chainWaitingOverdue: ["fulfil", "chain-waiting-overdue"],
  chainApproved: ["fulfil", "chain-approved"],
  chainChanges: ["fulfil", "chain-changes"],
  chainExpired: ["fulfil", "chain-expired"],
  chainNone: ["fulfil", "chain-none"],
  partySponsor: ["fulfil", "party-sponsor"],
  partyLeague: ["fulfil", "party-league"],
  partyTalent: ["fulfil", "party-talent"],
  partyLegal: ["fulfil", "party-legal"],
  partyInternal: ["fulfil", "party-internal"],
  partyVenue: ["fulfil", "party-venue"],
  captureStatus: ["capture", "capture-status"],
  captureStatusOffline: ["capture", "capture-status-offline"],
  captureOffline: ["capture", "capture-offline"],
  loading: ["states", "loading"],
  loadingPage: ["states", "loading-page"],
  loadFailedTitle: ["states", "load-failed-heading"],
  loadFailedBody: ["states", "load-failed-body"],
  loadFailedRequest: ["states", "load-failed-request"],
  loadFailedCode: ["states", "load-failed-code"],
  locked: ["states", "locked"],
  tableRows: ["states", "table-rows"],
  a11yGradeVerified: ["a11y", "grade-verified"],
  a11yGradeCaptured: ["a11y", "grade-captured"],
  a11yGradeAttested: ["a11y", "grade-attested"],
  a11yGradeMissing: ["a11y", "grade-missing"],
  a11yGradeUnconfirmed: ["a11y", "grade-unconfirmed"],
  a11yGradeDots: ["a11y", "grade-dots"],
  a11yDirWeOwe: ["a11y", "direction-we-owe"],
  a11yDirTheyOwe: ["a11y", "direction-they-owe"],
  a11yDirYouGet: ["a11y", "direction-you-get"],
  a11yDirYouOwe: ["a11y", "direction-you-owe"],
  a11yCodename: ["a11y", "codename"],
  a11yRegion: ["a11y", "region"],
  a11yDealCard: ["a11y", "deal-card"],
  a11yCaptureShutter: ["a11y", "capture-shutter"],
  a11yTermsSwitch: ["a11y", "terms-switch"],
  a11yTermsOn: ["a11y", "terms-on"],
  a11yTermsOff: ["a11y", "terms-off"],
  a11yCodeDigit: ["a11y", "code-digit"],
  a11yStepperDecrease: ["a11y", "stepper-decrease"],
  a11yStepperIncrease: ["a11y", "stepper-increase"],
  a11yStageDone: ["a11y", "stage-done"],
  a11yStageCurrent: ["a11y", "stage-current"],
  a11yStageFuture: ["a11y", "stage-future"],
  a11yNotifications: ["a11y", "notifications"],
  a11yExternal: ["a11y", "external"],
  a11yRemoveItem: ["a11y", "remove-item"],
  a11yPlanRegion: ["a11y", "plan-region"],
  a11yWhy: ["a11y", "why-subject"],
  a11yCheckPassed: ["a11y", "check-passed"],
  a11yCheckFailed: ["a11y", "check-failed"],
  agentReader: ["agents", "name-reader"],
  agentPlanner: ["agents", "name-planner"],
  agentWatch: ["agents", "name-watch"],
  agentVerifier: ["agents", "name-verifier"],
  agentChecker: ["agents", "name-checker"],
  agentReporter: ["agents", "name-reporter"],
  agentScout: ["agents", "name-scout"],
  agentPackager: ["agents", "name-packager"],
  agentRenewer: ["agents", "name-renewer"],
  agentMover: ["agents", "name-mover"],
  agentAssistant: ["agents", "name-assistant"],
  agentProspector: ["agents", "name-prospector"],
  bylineProposed: ["agents", "byline-proposed"],
  bylineFlagged: ["agents", "byline-flagged"],
  bylineFound: ["agents", "byline-found"],
  bylineWritten: ["agents", "byline-written"],
  navDealmap: ["nav", "dealmap"],
  navDeals: ["nav", "deals"],
  navQuickdeal: ["nav", "quickdeal"],
  navReader: ["nav", "reader"],
  navFulfil: ["nav", "fulfil"],
  navProof: ["nav", "proof"],
  navRoom: ["nav", "room"],
  navLookout: ["nav", "lookout"],
  navReports: ["nav", "reports"],
  navRequests: ["nav", "requests"],
  navInventory: ["nav", "inventory"],
  navScout: ["nav", "scout"],
  navPackage: ["nav", "package"],
  navRenew: ["nav", "renew"],
  navTalent: ["nav", "talent"],
  navPipeline: ["nav", "pipeline"],
  navSwitch: ["nav", "switch"],
  navPlaybooks: ["nav", "playbooks"],
  navConnect: ["nav", "connect"],
  navAssist: ["nav", "assist"],
  navClientrooms: ["nav", "clientrooms"],
  navBranddesk: ["nav", "branddesk"],
  navSettings: ["nav", "settings"],
  navCapture: ["nav", "capture"],
  navFindings: ["nav", "findings"],
  navProspector: ["nav", "prospector"],
  phAskAnything: ["placeholders", "ask-anything"],
  phCode: ["placeholders", "code"],
} as const satisfies Record<string, Msg>;

export type StringKey = keyof typeof S;
/** Ids this WP adds (everything except productName, which WP08 owns). */
export const WP09_STRING_KEYS: readonly StringKey[] = (Object.keys(S) as StringKey[]).filter((k) => k !== "productName");
